/**
 * "You" card - shows consumer's personal stats
 */
export default function YouCard({ data }) {
  // Handle undefined data with defaults
  const defaultData = {
    you: { premium: 1200, hasClaimThisYear: false, yearsWithoutClaim: 3, score: 0, level: 1 },
    premiumRate: 100
  };
  const safeData = data || defaultData;
  const { you, premiumRate } = safeData;
  const premiumChange = premiumRate - 100;
  const hasPremiumIncrease = premiumChange > 0;

  return (
    <div className="bg-[#1a1a1a] border-2 border-[#43e97b] rounded-xl p-6 shadow-[0_5px_20px_rgba(67,233,123,0.3)]">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 bg-[#43e97b] rounded-full flex items-center justify-center text-2xl">
          👤
        </div>
        <h3 className="text-2xl font-bold text-[#43e97b]">YOU</h3>
      </div>

      <div className="space-y-4">
        <div>
          <div className="text-xs text-[#888] uppercase tracking-wide mb-1">Your Premium</div>
          <div className="text-3xl font-bold text-white font-mono">
            ${you.premium.toLocaleString()}<span className="text-lg text-[#888]">/year</span>
          </div>
          {hasPremiumIncrease && (
            <div className="text-sm text-red-500 font-semibold mt-1">
              ↑ +{premiumChange.toFixed(0)}% increase
            </div>
          )}
        </div>

        <div className="pt-4 border-t border-[#333]">
          <div className="flex justify-between text-sm mb-2">
            <span className="text-[#888]">Claims Filed</span>
            <span className="text-[#43e97b] font-mono font-bold">{you.hasClaimThisYear ? 'YES' : 'NO'}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-[#888]">Years Without Claim</span>
            <span className="text-[#43e97b] font-mono font-bold">{you.yearsWithoutClaim}</span>
          </div>
        </div>

        {hasPremiumIncrease && (
          <div className="pt-4 border-t border-[#333]">
            <div className="bg-red-900/20 border border-red-900/50 rounded-lg p-3">
              <div className="text-xs text-red-400 font-semibold uppercase mb-1">⚠️ Why Did This Happen?</div>
              <div className="text-xs text-[#ccc] leading-relaxed">
                You had no claims, but the pool had major losses. Everyone's rate increased 
                to restore the carrier's target profit margin.
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


